import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import { Link } from 'react-router-dom';
import AccountIcon from '@material-ui/icons/AccountCircle';

const drawerWidth = 200;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
   
  },
  toolbar: theme.mixins.toolbar,
}));

function SideBar({children, room, users}) {
  const classes = useStyles();
  
  return (
    <div className={classes.root}>

      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.toolbar} />
        <List>
          <ListItem>
              <ListItemText primary={<Typography variant="subtitle1" align="center">Users</Typography>}/>
          </ListItem>
        </List>
        <Divider />
        <List>
          {users && users.map((user, index) => (
            <ListItem button key={user.connectionId}>
              <ListItemIcon><AccountIcon /></ListItemIcon>
              <ListItemText primary={user.identity.name} />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <main className={classes.content}>
        {children}
      </main>
    </div>
  );
}

export default SideBar;